import React from 'react';
import {
  NumericFormat as NumberFormat,
  NumericFormatProps,
} from 'react-number-format';

const PercentageText = ({ ...rest }: NumericFormatProps) => (
  <NumberFormat
    displayType={'text'}
    decimalScale={2}
    fixedDecimalScale={true}
    suffix={'%'}
    {...rest}
  />
);

export default PercentageText;
